
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/phone_multicomplete/templates/layout"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class='phone_multicomplete-suggestions'>\n  <div class='js-searchWrapper'></div>\n  <div class='js-suggestionsWrapper'></div>\n</div>\n\n<div class='js-tokensWrapper'></div>\n";
},"useData":true});
    }).call(this);
  